import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import Header from "../pages/navbar";
import Sidebar from "../pages/sidebar";
import { useUser } from "../context/UserContext";
import UserSidebar from "../pages/sidebar/userSideBar";

function MainLayout() {
  const navigate = useNavigate();
  const { user, isSimpleUser } = useUser();

  if (!user) return <Navigate to={"/login"} />;

  return (
    <>
      <div className=" main_layout vh-100 ">
        {/* Begin::Sidebar */}
        <div className="sidebar bg-white shadow-sm">
          <div className="logo-nav">
            <img
              src="/images/logo.svg"
              alt="logo"
              className="cursor-pointer"
              onClick={() => navigate("/")}
            ></img>
          </div>
          {isSimpleUser ? <UserSidebar /> : <Sidebar />}
          {/* Sidebar Footer*/}
          <div
            className="flex items-center gap-1 py-1 px-3"
            style={{ borderTop: "2px solid #f0f2f7" }}
          >
            <div className="profile-symbol w-[1.7rem] h-[1.7rem]">
              <img
                src="https://plus.unsplash.com/premium_photo-1671656349322-41de944d259b?w=700&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8bWFufGVufDB8fDB8fHww"
                alt=""
                className="symbol-img"
              />
            </div>
            <div>
              <h5 className="mb-0 text-blue text-sm">
                {user.name || user.username}
              </h5>
              <p className="text-[#A4A8B5] font-medium text-xs">
                {user.emailId || "dummy@gmail.com"}
              </p>
            </div>
          </div>
        </div>
        {/* End::Sidebar */}

        {/* Begin:Content Area */}
        <div className="content bg-seondary">
          <Header />
          <div className="px-[10px] xs:px-3">
            <Outlet />{" "}
          </div>
        </div>
        {/* End:Content Area */}
      </div>
    </>
  );
}

export default MainLayout;
